import { BoxContainer, PrimaryButton, ReactIcons } from "@kalyzee/kalyzee-ui";
import React from "react";

import workBoxStyles from "./WorkBox.module.css";

export interface MediaSourceWorkBoxProps {
  children: React.ReactNode;
  onClose?: () => void;
  style?: React.CSSProperties;
  className?: string;
}

export const MediaSourceWorkBox: React.FC<MediaSourceWorkBoxProps> = ({
  children,
  onClose,
  style,
  className,
}) => {
  return (
    <BoxContainer
      style={{ width: "100%", height: "100%", ...style }}
      className={className}
      topBarProps={{
        left: [
          <ReactIcons.PlayScreens style={{ width: "1.5em", height: "1.5em" }} />,
        ],
        center: [
          <span className={workBoxStyles.label}>Sources</span>,
        ],
        right: onClose ? [
          <PrimaryButton onClick={onClose}>
            <ReactIcons.Close style={{ height: "0.8em" }} />
          </PrimaryButton>,
        ] : [],
      }}
    >
      {children}
    </BoxContainer>
  );
};
